import React from "react";

import { Props } from "./types";

function PenIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="14.1 14.1 14.2 14.2">
      <g transform="translate(8260 10958)">
        <path
          d="M6.94,2.226,10,5.282,3.36,11.918l-2.725.3A.573.573,0,0,1,0,11.586l.3-2.727L6.94,2.226Zm4.946-.455L10.451.336a1.146,1.146,0,0,0-1.621,0L7.48,1.686l3.056,3.056,1.35-1.35a1.146,1.146,0,0,0,0-1.621Z"
          transform="translate(-8244.11 -10943.111)"
        />
      </g>
    </svg>
  );
}

export { PenIcon };
